// BannerSection.js
import React from 'react';

const BannerSection = ({ sections }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column',  width: '101%' }}>
      {sections.map((section, index) => (
        <div
          key={index}
          style={{
            position: 'relative',
             width: '100%', 
            height: section.height || '300px', // กำหนดความสูงแต่ละ section
            backgroundImage: `url(${section.image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderRadius: '0px',
            overflow: 'hidden',
            marginTop: '20px',
            fontFamily: "'Roboto Condensed', 'Kanit', sans-serif"
          }}
        >
          {/* Overlay สีและข้อความ */}
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: section.overlayColor || 'rgba(0,0,0,0.4)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: section.align || 'center',
              color: '#fff',
              padding: '20px',
              textAlign: section.textAlign || 'center',
            }}
          >
            <h2 style={{ fontSize: '2rem', marginBottom: '10px' }}>{section.title}</h2>
            <p style={{ fontSize: '1rem', marginBottom: '15px' }}>{section.subtitle}</p>
            {section.buttonText && section.buttonLink && (
              <a
                href={section.buttonLink}
                style={{
                  
                  backgroundColor: '#fca311',
                  color: '#fff',
                  padding: '10px 20px',
                  borderRadius: '6px',
                  textDecoration: 'none',
                  fontWeight: 'bold',
                }}
              >
                {section.buttonText}
              </a>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default BannerSection;
